import { useTranslation } from "react-i18next";

import MTBreadcrumb from "@app-components/header/MTBreadcrumb";
import ShippingContent from "@app-components/policy/ShippingContent";
import { getRoutes } from "@app-utils/routes";

export default function ShippingPolicyPage() {
  const { t } = useTranslation();
  const routes = getRoutes(t);

  return (
    <div className="container policy faq-detail">
      <MTBreadcrumb items={[routes.home, routes.shipping]} />
      <div className="faq-detail-container">
        <div className="wrapper">
          <div className="faq-detail-header">
            <div className="faq-detail-header-container">
              <div className="faq-detail-title">{t("page.shipping.title")}</div>
            </div>
          </div>
          <ShippingContent />
        </div>
      </div>
    </div>
  );
}
